module.exports = __webpack_public_path__ + "static/media/push.521e9c05.svg";